<template>
    <Content>
        <div class="product-principal-cart">
            <h2>
                <template v-if="showCodeOriginal">
                    {{ product.api_cod_original }} -
                </template>
                {{ product.pro_name_site }}
            </h2>

            <span>
                <strong>
                    {{ product.qtd_cart }}
                    <template v-if="getShowUnitOfMeasureInProductPrice">
                        {{ product.pro_sigla_medida }}
                    </template>
                    X {{ productPrice }}
                </strong>
                   <p v-if="show_ipi" style="font-size: 1.1rem">+ {{ product.ipi_percentage }} % de IPI</p>
            </span>

            <span v-if="product.fractional_sale">
                <strong>Peso: </strong>
                {{ product.fractional_quantity }}
                {{ product.fractional_label }}
            </span>

            <template v-if="!product.is_product_group">
                <span v-if="product.size_name_cart">
                    <strong>Tamanho:</strong>
                    {{ product.size_name_cart }}
                </span>
                <span v-if="product.color_name_cart">
                    <strong v-if="product.type == 'COLOR'">Cor:</strong>
                    <strong v-if="product.type == 'ESTAMPA'">Estampa:</strong>
                    {{ product.color_name_cart }}
                </span>

                <template v-if="product.items_grid_abbreviaton">
                    <span>{{ product.items_grid_abbreviaton }}</span>
                </template>
                <template v-else>
                    <span
                        v-if="product.grid_group_column_value"
                        class="text-capitalize"
                    >
                        <strong>
                            {{ product.grid_group_column_name.toLowerCase() }}:
                        </strong>
                        {{ product.grid_group_column_value }}
                    </span>
                    <span
                        v-if="product.grid_group_row_value"
                        class="text-capitalize"
                    >
                        <strong>
                            {{ product.grid_group_row_name.toLowerCase() }}:
                        </strong>
                        {{ product.grid_group_row_value }}
                    </span>
                </template>

                <template v-if="product.flavors && product.flavors.length">
                    <span class="product-flavors-cart">
                        <strong>
                            {{
                                product.flavors.length > 1
                                    ? "Sabores"
                                    : "Sabor"
                            }}:
                        </strong>
                    </span>
                    <span
                        class="dropdown__flavor"
                        v-for="flavor in product.flavors"
                        :key="flavor.id"
                    >
                        {{ flavor.name }}
                    </span>
                </template>
            </template>
        </div>

        <figure>
            <a href="#" class="image-product-cart">
                <img
                    :src="product.image_main"
                    :alt="`Produto ${product.pro_name_site.toLowerCase()}`"
                />
            </a>
            <a
                href="#"
                class="remove-product-cart"
                @click.prevent="$emit('removeProduct', product)"
                title="Remover produto"
            >
                <i class="icon-cancel"></i>
            </a>
        </figure>

        <template v-if="children">
            <div class="product-children-cart">
                <template v-for="(child, key) in children">
                    <div
                        :key="`${product.key_loop}-${key}`"
                        class="product-child-cart"
                    >
                        <span>
                            {{ child.qtd_cart }} X {{ child.pro_name_site }}
                        </span>
                        <span v-if="!child.is_product_group">
                            {{ currency.money(child.pro_price_site) }}
                        </span>
                    </div>
                </template>
            </div>
        </template>
    </Content>
</template>

<script>
import { mapGetters } from "vuex";
import Currency from "../../../helpers/parseCurrency";
import { Content } from "./style";

export default {
    name: "CartProduct",
    props: {
        product: {
            required: true
        },
        children: {
            default: null
        }
    },
    components: {
        Content
    },
    data() {
        return {
            currency: Currency
        };
    },
    computed: {
        ...mapGetters("company", [
            "showCodeOriginalBesideDescription",
            "getShowUnitOfMeasureInProductPrice",
            "showIpi"
        ]),
        productPrice() {
            return this.currency.money(
                this.product.price_to ?? this.product.pro_price_site
            );
        },
        showCodeOriginal() {
            return (
                this.showCodeOriginalBesideDescription &&
                this.product.api_cod_original
            );
        },
        show_ipi() {
            return (this.showIpi && this.product?.ipi_percentage)
        },
    }
};
</script>
